const Throbber = () => {
  return (
    <div>
      <img src="/images/loading.gif" style={{height: "24px", width:"24px"}} alt="loading"/>
    </div>
  )
}

export default Throbber